<input #editInput *ngIf="column.type === 'text'" type="text" class="cell-input"
  [(ngModel)]="editingValue" (keydown)="onInputKeydown($event)"
  [attr.aria-label]="'Editing ' + column.label"
  [attr.aria-describedby]="editHintId" />

<input #editInput *ngIf="column.type === 'number' || column.type === 'currency'" type="number"
  class="cell-input" [(ngModel)]="editingValue" (keydown)="onInputKeydown($event)"
  [attr.aria-label]="'Editing ' + column.label"
  [attr.aria-describedby]="editHintId" />

<input #editInput *ngIf="column.type === 'date'" type="date" class="cell-input"
  [(ngModel)]="editingValue" (keydown)="onInputKeydown($event)"
  [attr.aria-label]="'Editing ' + column.label"
  [attr.aria-describedby]="editHintId" />

<div *ngIf="column.type === 'select'" class="cell-listbox-wrapper">
  <button #editInput class="cell-listbox-trigger" type="button"
    role="combobox"
    [attr.aria-expanded]="true"
    aria-haspopup="listbox"
    [attr.aria-controls]="'listbox-' + column.key + '-' + rowId"
    [attr.aria-activedescendant]="'option-' + column.key + '-' + rowId + '-' + listboxHighlightIndex"
    [attr.aria-label]="column.label + ': ' + (getOptionLabel(editingValue) || 'none selected')"
    [attr.aria-describedby]="editHintId"
    (keydown)="onListboxKeydown($event)">
    {{ getOptionLabel(editingValue) || 'Select...' }}
    <lucide-angular class="select-chevron" name="chevron-down" [size]="12" aria-hidden="true"></lucide-angular>
  </button>
  <div class="cell-listbox"
    [id]="'listbox-' + column.key + '-' + rowId"
    role="listbox"
    [attr.aria-label]="column.label + ' options'"
    style="display: none;"
    (mousedown)="$event.stopPropagation()">
    <div *ngFor="let option of column.selectOptions; let i = index"
      class="listbox-option"
      role="option"
      [id]="'option-' + column.key + '-' + rowId + '-' + i"
      [attr.aria-selected]="editingValue === option.value"
      [attr.aria-posinset]="i + 1"
      [attr.aria-setsize]="column.selectOptions?.length"
      [class.selected]="editingValue === option.value"
      [class.highlighted]="listboxHighlightIndex === i"
      (mousedown)="$event.stopPropagation()"
      (click)="selectOption(option.value, $event)"
      (mouseenter)="listboxHighlightIndex = i">
      {{ option.label }}
    </div>
  </div>
</div>
